<template>
  <v-flex v-if="!isError" class="list-toolbar-wrapper">
    <v-row align="center">
      <v-col v-if="isStatisticLoading">
        <Loaders type="dataField" />
      </v-col>
      <v-col v-else-if="props.statistic">
        <Statistic
          v-if="isStatisticFetched || isStatisticError"
          :value="props.statistic.value"
          :isError="isStatisticError"
          :isFetched="isStatisticFetched"
          :i18nLabel="props.i18nLabel"
        />
        <Loaders
          v-else-if="!isStatisticError"
          type="dataField"
        />
      </v-col>
      <v-col>
        <v-flex>
          <v-row
            v-if="isLoading && !isFetched"
            no-gutters
            justify="end"
          >
            <Loaders type="paginationControls" />
          </v-row>
          <v-row
            v-else
            no-gutters
            justify="end"
          >
            <Paginator
              :currentIndex="props.paginationStart"
              :elementsPerPage="props.elementsPerPage"
              :undeterminate="false"
              :numberOfElements="props.numberOfElements"
              :disableNextPage="props.isLastPage || isLoading"
              @page-change="e => $emit('page-navigation-handler', e)"
              @go-to-page="$emit('go-to-page', $event)"
            />
          </v-row>
        </v-flex>
      </v-col>
    </v-row>
  </v-flex>
</template>

<script setup lang="ts">
import { computed, PropType } from 'vue';
import './styles/list-toolbar.scss';
import Loaders from '@/components/common/Loaders/Loaders.vue';
import Statistic from '@/components/common/Statistic/Statistic.vue';
import Paginator from '@/components/common/Paginator/Paginator.vue';

const props = defineProps({
  state: {
    type: Object as PropType<{ [key: string]: boolean }>,
    default: () => ({})
  },
  statisticDataState: {
    type: Object as PropType<{ [key: string]: boolean }>,
    default: () => ({})
  },
  statistic: {
    type: Object as PropType<{ value: number, label: string, labelSuffix: string }>,
    default: () => ({})
  },
  paginationStart: {
    type: Number,
    default: 0
  },
  elementsPerPage: {
    type: Number,
    default: 20
  },
  isLastPage: {
    type: Boolean,
    default: false
  },
  numberOfElements: {
    type: Number,
    default: 10
  },
  i18nLabel: {
    type: String,
    default: ''
  }
});

const isStatisticLoading = computed(() => props.statisticDataState.loading && !props.statisticDataState.fetched);

const isStatisticFetched = computed(() => props.statisticDataState.fetched);

const isStatisticError = computed(() => props.statisticDataState.error);

const isLoading = computed(() => props.state.loading);

const isFetched = computed(() => props.state.fetched);

const isError = computed(() => props.state.error);
</script>
